// Dependencias
import { logout } from '../service/auth.service';

// Elementos HTML del DOM
const logutElement = document.querySelector<HTMLAnchorElement>('#logout');

/**
 *
 */
export function main() {
  logutElement?.addEventListener('click', async(e) => {
    try {
      e.preventDefault();
      await logout();

      location.href = '/';
    } catch (error) {
      console.log(error);
    }
  });
}
